import React from "react";
import "./style.css";

const Skills = () => {
    return (
        <section className="skills">
            <h2 className="skills__title">skills</h2>
            <div className="skills__wrapper">
                <div className="skills__item">
                    react
                </div>
                <div className="skills__item">
                    nextjs
                </div>
                <div className="skills__item">
                    scss modules
                </div>
                <div className="skills__item">
                    typescript
                </div>
                <div className="skills__item">
                    redux
                </div>
                <div className="skills__item">
                    rest api
                </div>
                <div className="skills__item">
                    javascript
                </div>
                <div className="skills__item">
                    html5
                </div>
                <div className="skills__item">
                    css3
                </div>
                <div className="skills__item">
                    react native
                </div>
                <div className="skills__item">
                    git
                </div>
                <div className="skills__item">
                    vite
                </div>
                <div className="skills__item">
                    scss/less
                </div>
                <div className="skills__item">
                    gulp/webpack
                </div>
                <div className="skills__item">
                    ux/ui
                </div>
                <div className="skills__item">
                    figma/photoshop
                </div>
                <div className="skills__item">
                    bem
                </div>
                <div className="skills__item">
                    english
                </div>
            </div>
        </section>
    );
};

export default Skills;